import PropTypes from 'prop-types'
import React, { Children, Component } from 'react'
import cx from 'classnames'
import { List } from 'immutable'

import Avatar, { userHasAvatar } from 'shared-web/src/components/Avatar'
import styles from './style.styl'

const WelcomeMessageAvatar = ({ user, backgroundColor }) => (
  <div className={styles.AvatarWrapper}>
    <Avatar
      user={user}
      style={{ borderColor: `#${backgroundColor}` }}
      shape="circle"
    />
  </div>
)
WelcomeMessageAvatar.propTypes = {
  backgroundColor: PropTypes.string,
  user: PropTypes.object,
}

function MenuItem({ children, foregroundColor, ...props }) {
  return (
    <div {...props} className={styles.MenuItem} 
    style={{ color: `#${foregroundColor}` }}>
      {children}
    </div>
  )
}
MenuItem.propTypes = {
  children: PropTypes.node,
}
function Menu({ children, foregroundColor, ...props }) {
  return (
    <div className={styles.Menu} {...props}>
      <div className={styles.MenuItems}>
        {Children.map(children, (child) => (
          <MenuItem foregroundColor={foregroundColor}>{child}</MenuItem>
        ))}
      </div>
    </div>
  )
}
Menu.propTypes = {
  children: PropTypes.node,
}

function WelcomeMessageAvatars({ children }) {
  return Children.count(children) > 0 && (
    <div className={styles.AvatarsList}>
      {
        /* We render children in reverse order and visually "flip" the ordering back using
        `flex-direction: row-reverse`. This keeps the children in the same order visually,
         but with the stacking contexts reversed, so that the nth child can overlap the
         nth+1 child. */
        Children.toArray(children).reverse()
      }
    </div>
  )
}
WelcomeMessageAvatars.propTypes = {
  children: PropTypes.node,
}

class WelcomeMessageHeader extends Component {
  static propTypes = {
    title: PropTypes.node,
    message: PropTypes.node,
    menu: PropTypes.node,
    children: PropTypes.node,
    users: PropTypes.object,
    backgroundColor: PropTypes.string,
    foregroundColor: PropTypes.string,
  }

  static defaultProps = {
    users: List(),
  }

  renderUserAvatars() {
    const { users } = this.props
    if (!users || users.isEmpty()) {
      return null
    }
    if (users.size === 1 && !userHasAvatar(users.first())) {
      return null
    }
    return (
      <WelcomeMessageAvatars>
        {users.map(this.renderAvatar)}
      </WelcomeMessageAvatars>
    )
  }

  renderAvatar = (user) => {
    const { id: key, publicProfileUrl } = user
    const { backgroundColor } = this.props
    const avatarProps = { user, backgroundColor }
    if (publicProfileUrl) {
      return (
        <a key={key} href={publicProfileUrl} target="_blank">
          <WelcomeMessageAvatar {...avatarProps}/>
        </a>
      )
    } else {
      return (
        <WelcomeMessageAvatar key={key} {...avatarProps}/>
      )
    }
  }

  render() {
    const {
      backgroundColor,
      foregroundColor,
      title,
      children,
      users,
      menu,
    } = this.props

    const hasUsers = users.size > 0
    const hasMultipleAvatars = users.size > 1
    return (
      <div
        className={cx(styles.Container, { [styles.MultiAvatars]: hasMultipleAvatars })}
        style={{ backgroundColor: `#${backgroundColor}`, color: `#${foregroundColor}` }}
      >
        {(hasUsers || title) && (
          <div className={styles.Header}>
            <div className={styles.HeaderContent}>
              {this.renderUserAvatars()}
              {title && (
                <div
                  className={styles.Title}
                  style={{ color: `#${foregroundColor}` }}
                >
                  {title}
                </div>
              )}
            </div>
            <Menu foregroundColor={foregroundColor}>
              {menu}
            </Menu>
          </div>
        )}
        <div className={styles.Body}>
          {children}
        </div>
      </div>
    )
  }
}

export default WelcomeMessageHeader



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageHeader/index.js